import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { useIsAnyIcasLoading } from './useIcasGeoJson';

/**
 * Floating chip pinned to the top-center of the map container. Visible
 * whenever any ICAS GeoJSON layer is mid-fetch (entitati 200-300 KB or
 * trupuri ~7 MB). Returns null when nothing is loading so the indicator
 * never blocks map clicks.
 *
 * Must be mounted as a *sibling* of `<MapContainer>` (i.e. inside the
 * same positioned parent), not as a child — Leaflet's pane DOM would
 * otherwise capture the absolute positioning.
 */
export function IcasLoadingIndicator() {
  const loading = useIsAnyIcasLoading();
  const { t } = useTranslation(['common']);
  if (!loading) return null;
  return (
    <div className="pointer-events-none absolute left-1/2 top-3 z-[1000] -translate-x-1/2">
      <div className="pointer-events-auto flex items-center gap-2 rounded-full bg-white/95 px-3 py-1.5 text-xs font-medium text-slate-700 shadow-md ring-1 ring-slate-200 backdrop-blur dark:bg-slate-800/95 dark:text-slate-200 dark:ring-slate-700">
        <Loader2 className="h-3.5 w-3.5 animate-spin text-emerald-600" />
        {t('common:icas.loading', { defaultValue: 'Se încarcă straturile ICAS…' })}
      </div>
    </div>
  );
}
